import Bio from "../components/Bio";
import OnWeb from "../components/OnWeb";
import Header from "../components/Header";
const Home = () => {
return (
    <>
    <Header />
    <Bio />
    <OnWeb />
    </>
)
}
export default Home;